import React, { HTMLProps, useMemo } from "react";
import { ReactNode } from "react";
import { Content } from "../Content";

type ListProps<T> = {
  items: T[];
  template: (item: T) => ReactNode;
  children?: ReactNode;
  title?: string;
} & HTMLProps<HTMLDivElement>;

function List<T>({ items, template, children, title, ...props }: ListProps<T>) {
  const titleElement = useMemo(
    () =>
      React.Children.toArray(children).filter(
        (child) => React.isValidElement(child) && child.type === Content,
      )[0],
    [children],
  );

  return (
    <div {...props}>
      <div className="mb-2 flex items-center font-bold">
        {titleElement ? (
          titleElement
        ) : (
          <>
            <span>{title}</span>
            <div className="ml-4 flex h-7 w-7 items-center justify-center rounded-full bg-th-primary-900 font-bold text-white">
              {items?.length ?? 0}
            </div>
          </>
        )}
      </div>
      <div className="flex flex-col space-y-2">
        {items.map((item) => template(item))}
      </div>
    </div>
  );
}

List.Title = Content;

export default List;
